import { KngButtonPosition, KngButtonSize, KngButtonState, KngButtonStyle } from 'kinetic-angular';

export interface ContactUs {
  state: ContactUsState;
}
export interface ContactUsState {
  loading: boolean;
  pageHeading: string;
  sectionTopHeading: string;
  pageSubHeading: string;
  sectionTopData: Array<SectionTopInput>;
  sectionBottomHeading: string;
  sectionBottom: SectionBottom;
  buttons: Buttons;
  response: Response;
  comments: SectionTopInput;
	toasterSuccess: ToastrMsg;
	toasterFailure: ToastrMsg;
  subreasonLabelData: SubReasonLabelData;
}

export interface AemContactUsLabelData {
  pageHeading: string;
  pageSubHeading: string;
  sectionTopHeading: string;
  sectionTopData: Array<AemSectionTopInput>;
  sectionBottomHeading: string;
  sectionBottom: SectionBottom;
  buttons: AemButtons;
  comments: AemSectionTopInput;
	toasterSuccess: ToastrMsg;
	toasterFailure: ToastrMsg;
  subreasonLabelData: SubReasonLabelData;
}

interface ToastrMsg {
  label: string;
}

interface AemButtons {
  submit: string;
  cancel: string;
}
interface Response {
  data: object;
  isInvalid: boolean;
  emailErrorMessage: string;
}

export interface ContactUsPayload {
  subject: string;
  description: string;
  requestorFirstName: string;
  requestorLastName: string;
  country: string;
  addressLine1: string;
  zipCode: string;
  city: string;
  state: string;
  companyName: string;
  email: string;
  accountType?:string;
  roleOfUser?:string;
  primaryLocationGRID?:string;
  adminLocationGRID?:string;
  crmRecordExists?:string;
  customerType?:string;
  urlOfOrigin ?:string;
}


interface SectionBottom {
  dropdownLabel: string;
  isRequired: boolean;
  errorMsg?: string;
  dropDownData: Array<SectionBottomSelect>;
}
interface Buttons {
  submit: KngButtonState;
  cancel: KngButtonState;
}

export interface ButtonType {
  size?: KngButtonSize;
  style?: KngButtonStyle;
  disabled?: boolean;
  label: string;
  position?: KngButtonPosition;
}

export interface SectionTopInput {
  label: string;
  placeholder: string;
  errorMsg: string ;
  isRequired: boolean ;
  id: string;
  type: string ;
}
export interface AemSectionTopInput {
  label: string;
  placeholder: string;
  errorMsg: string ;
  isRequired: boolean ;
}


export interface SubMenu {
  label: string;
}

export interface SectionBottomSelect {
  label: string;
  subMenu: Array<SubMenu>;
  isOpen?: boolean;
}

export enum FieldType {
  text = 'text',
  email = 'email',
  phone = 'phone',
  textarea = 'textarea',
  select = 'select',
}

export enum SubReasonLables {
  label= 'Specific Input (Optional)',
  placeholder= 'Please Enter Details Here'
};

export enum FormState {
  firstName= 'firstName',
  lastName= 'lastName',
  email= 'email',
  phone= 'phone',
  companyName= 'companyName',
  address= 'address',
  city= 'city',
  state= 'state',
  zipCode= 'zipCode',
  country= 'country',
  reason= 'reason',
  reasonInput= 'reasonInput',
  comments= 'comments',
  phoneNumber = 'phoneNumber',
}

export enum SubReasonLabel {
  partsOrder = 'Parts Order',
  equipmentOrder = 'Equipment Order',
  checkoutIssue = 'Checkout Issue',
  manualInformation = 'Manuals',
  partInformation = 'Part Information',
  otherInformation = 'Other',
  invoiceNumber = 'Invoice',
  myToyotaStoreEquipmentOrder = 'MyToyota Store Equipment Order',
  toyotaDealerEquipmentOrder = 'Toyota Dealer Equipment Order',
}

export interface SubReasonLabelData {
  partInformation: [SubReasonIndividualLabelData];
  invoiceNumber: [SubReasonIndividualLabelData];
  partsOrder: [SubReasonIndividualLabelData];
  equipmentOrder: [SubReasonIndividualLabelData];
  manualInformation: [SubReasonIndividualLabelData];
  myToyotaStoreEquipmentOrder: [SubReasonIndividualLabelData];
  toyotaDealerEquipmentOrder: [SubReasonIndividualLabelData];
}
export interface SubReasonIndividualLabelData {
  label: string;
  placeholder: string;
}

export interface UserData {
  firstName:string;
  lastName:string;
  email:string;
  phoneNumber:string;
  companyName:string;
  addressLine1?:string;
  city?:string;
  state?:string;
  zipCode?:string;
  country?:string;
  accountType?:string;
  role?:string;
  primaryLocationGRID?:string;
  adminLocationID?:string;
  crmRecordExists?:boolean;
  customerType?:string;
  urlOfOrigin ?:string;
}
